import { ProgressIndicatorStatus } from './WidgetMetricTile';

export const getDefaultStatus = (percentage: number): ProgressIndicatorStatus => {
  if (percentage <= 97) return 'SAD';
  if (percentage <= 99) return 'CONFUSED';
  return 'HAPPY';
};
